module.exports = __webpack_public_path__ + "img/JM.4daaf707.svg";